<xemex-card [title]="'installationGroups.detail.installations' | translate" [loading]="loading()">
  @if (!rows().length) {
    <xemex-no-items-found [compact]="true" message="installationGroups.installations.empty" />
  } @else {
    <div class="flex flex-col divide-y divide-border-subtle">
      @for (row of rows(); track row.installationOid) {
        <xemex-list-row
          icon="electric_bolt"
          align="start"
          [title]="row.name"
          [subtitle]="row.address"
          [clickable]="true"
          (rowClick)="viewInstallation.emit(row.installationOid)"
        >
          <ng-container listRowBadges>
            <xemex-tag
              [state]="row.status === 'Active' ? 'success' : 'neutral'"
              [label]="'installations.status.' + row.status | translate"
            />
            @if (row.ownedByOtherPartner) {
              <xemex-tag
                state="info"
                icon="business"
                [label]="row.partnerName"
                [matTooltip]="'installationGroups.installations.otherOwner' | translate"
              />
            }
          </ng-container>
          <div class="mt-1 flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-text-secondary">
            @if (!row.ownedByOtherPartner && row.partnerName) {
              <span class="truncate">{{ row.partnerName }}</span>
            }
            @if (row.viaDeviceId === null) {
              <xemex-link-button icon="home_work" (click)="onViewLocation(row.locationId, $event)">
                {{ 'installationGroups.installations.viaLocation' | translate }}
              </xemex-link-button>
            } @else {
              <xemex-link-button icon="router" (click)="onViewDevice(row.viaDeviceId, $event)">
                {{
                  'installationGroups.installations.viaDevice'
                    | translate: { ldn: row.viaDeviceLabel }
                }}
              </xemex-link-button>
            }
          </div>
          <mat-icon listRowActions class="text-text-muted !text-lg">chevron_right</mat-icon>
        </xemex-list-row>
      }
    </div>
    @if (total() > pageSize()) {
      <xemex-table-pagination
        [page]="page()"
        [totalPages]="totalPages()"
        [total]="total()"
        [pageSize]="pageSize()"
        [compact]="true"
        (pageChange)="pageChange.emit($event)"
      />
    }
  }
</xemex-card>
